import IMask, { MaskedOptions } from 'imask';
import React, { useLayoutEffect, useRef } from 'react';

import { Input } from '../Input';

export type TOptions = {
	options: MaskedOptions;
};

// NOTE: See: https://imask.js.org/
const MaskedInput = ({ options, ...props }) => {
	const input = useRef<HTMLInputElement>(null);

	useLayoutEffect(() => {
		if (input.current) {
			IMask(input.current, options);
		}
	}, []);

	return <Input ref={input} {...props} />;
};

export { MaskedInput };
